import {Component, OnDestroy, OnInit} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {Subject} from 'rxjs';
import {AppService} from 'app/services/app.service';

import { locale as english } from './i18n/en';
import { locale as italiano } from './i18n/it';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
	selector: 'resource-sub-type-documentation-dialog',
	templateUrl: 'dialog.component.html',
	styleUrls: ['./dialog.component.scss']
})
export class ResourceSubTypeDocumentationDialogComponent implements OnDestroy, OnInit {

	protected _unsubscribeAll: Subject<any>;

	constructor(
		public appService: AppService,
		public dialogRef: MatDialogRef<void>,
		private fuseTranslationLoader: FuseTranslationLoaderService
	) {
		this._unsubscribeAll = new Subject();
		this.fuseTranslationLoader.loadTranslations(english, italiano);
	}

	ngOnInit(): void{}

	onYesClick(): void {
		this.dialogRef.close(true);
	}

	ngOnDestroy(): void{
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
}
